#@import Booking.Models.Base
#@export Booking.Models.PartySize

class Booking.Models.PartySize extends Booking.Models.Base

  getPartySize: ->
    @get('partySize')
